<template>
  <div>
    <div class="main">
      <el-form :model="formData" ref="formDataRef" label-position="left">
        <el-form-item prop="title" :label="$t('newsAnncmnt.titleName')">
          <el-input
            size="noticeInput"
            v-model="formData.title"
            @change="formData.title = formData.title.trimStart().trimEnd()"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <!-- 简介 -->
        <el-form-item prop="synopsis" :label="$t('newsAnncmnt.introduction')">
          <el-input
            type="textarea"
            style="margin-bottom:8px;"
            size="noticeContentInput"
            :rows="7"
            v-model="formData.synopsis"
          ></el-input>
        </el-form-item>
        <!-- 上传封面图 -->
        <el-form-item
          prop="coverLocationCode"
          :label="$t('newsAnncmnt.coverLocationCode')"
          style="display: flex;flex-direction: column;"
        >
          <el-row>
            <el-col style="width: 230px;">
              <!-- 上传封面图 -->
              <asqmsUploadImg
                style="border: 1px dashed #d7d7d7;"
                ref="asqmsUploadImgRef"
                :uploadButtonStyle="2"
                :uploadFile="{
                  locationCode: formData.coverLocationCode,
                  uploadBtnDisplayFlag: true
                }"
              />
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 新闻与公告详情 -->
        <el-form-item
          prop="content"
          :label="$t('newsAnncmnt.content')"
          style="display: flex;flex-direction: column;"
        >
          <editor
            v-model="formData.content"
            :asqmsFlag="true"
          ></editor>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadFile from "@/components/Common/UploadAttachment.vue";
import autoUploadFile from "@/components/Common/AutoUploadImg.vue";
import uploadImg from "@/components/Common/UploadImg.vue";
import Editor from "@/components/imcoder-tinymce";
import asqmsUploadImg from "@/components/Common/AsqmsUploadImg.vue";
export default {
  props: {
    query: {
      type: Object,
      required: true
    }
  },
  components: {
    asqmsUploadImg,
    Editor,
    uploadFile,
    uploadImg,
    autoUploadFile
  },
  data() {
    return {
      formData: this.$props.query.data,
      titleHead: ""
    };
  },
  // 监听
  watch: {},
  methods: {
    async submit() {
      // 上传封面图片
      await this.$refs.asqmsUploadImgRef.submitUploadFile();
    },
    init() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/newsAnncmnt/getDetail";
      this.$http
        .post(url, {
          ...this.formData
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.formData = response.data.data;
            this.$nextTick(() => {
              this.$refs.asqmsUploadImgRef.init();
            });
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 返回
    returnPage() {
      this.$router.push({
        path: "/views/Asqms/views/NewsAnncmnt/Index",
        query: {
          ...this.$route.query
        }
      });
    }
  },
  mounted() {
    if (this.$props.query.titleHead) {
      this.titleHead =
        this.$route.query.titleHead === "add"
          ? this.$t("common.new")
          : this.$t("common.edit");
    }
    if (this.$props.query.id) {
      this.formData.id = this.$props.query.id;
      this.formData.newsNo = this.$props.query.newsNo;
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  padding-top: 17px;
  // display: flex;
}

>>> .el-form-item {
  margin-bottom: 0%;
  text-align: left;
}
.couponType >>> .el-form-item__content {
  line-height: 30px;
}
.foot-container {
  margin: 40px auto 0 auto;
  height: 26px;
  text-align: center;
}
.noticeInputCenter >>> .el-input__inner {
  text-align: center;
  // font-size: 18px;
}
// 遮罩颜色
>>> .el-dialog__wrapper {
  background: rgba(88, 88, 88, 0.4);
}
>>> .el-dialog__body {
  color: #000000;
  font-family: sans-serif;
}
>>> .el-form-item__label {
  font-size: 16px;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/views/Asqms/views/NewsAnncmnt/EditCell.vue